import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import stylesPay from './ButtonPayAnti.module.less';

import { logging } from '../../actions/log';
import { setAntiErr } from '../../actions/buttonpay';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectButtonPay = createSelector(
  state => state.buttonpay,
  buttonpay => buttonpay,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { btnPayAntiErr } = useSelector(selectButtonPay);

  useEffect(() => {
    loggingOrder('P', 'PayGame_Payment_Limit');
  }, []);

  const loggingOrder = useCallback(
    (category, action) => {
      dispatch(
        logging({
          category: category || 'C',
          action: action || 'PayGame_Payment_Limit',
          label: '',
          param2: {
            source: btnPayAntiErr?.logInfo?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            softid: btnPayAntiErr?.soft?.softID,
            softName: btnPayAntiErr?.soft?.softName,
            softType: '0',
          },
          param3: btnPayAntiErr?.soft?.bizInfo || null,
        }),
      );
    },
    [btnPayAntiErr, logInfoData],
  );

  const handleDialogClose = useCallback(flag => {
    loggingOrder(
      'C',
      flag ? 'PayGame_Payment_Limit_Sure' : 'PayGame_Payment_Limit_Close',
    );
    dispatch(setAntiErr({}));
  }, []);

  return (
    <div className={stylesPay.dialog_box}>
      <div className={stylesPay.dialog_order}>
        <div className="order_header">
          <div className="order_header_text">温馨提示</div>
          <div
            className="order_header_close iconfont icon-opt_close"
            onClick={() => {
              handleDialogClose();
            }}
          ></div>
        </div>
        <div className="order_cont">
          <div className={'order_text'}>
            亲爱的用户您好，根据《关于防止未成年人沉迷网络游戏的通知》有关规定，您无法购买该游戏。
          </div>
          <div
            className={'btn_sure'}
            onClick={() => {
              handleDialogClose(true);
            }}
          >
            确定
          </div>
        </div>
      </div>
    </div>
  );
});
